import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../../services/projects/projects.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-view-payment-term",
  templateUrl: "./view-payment-term.component.html",
  styleUrls: ["./view-payment-term.component.css"],
})
export class ViewPaymentTermComponent implements OnInit {
  previewPayments: any;
  finishing_types: any;
  finish_type_name: any;
  currentSelectedProjectName: any;
  payment_id: any;
  extraPayments = [];
  projects: any;
  payment_plan_details_clone: any;
  clone_type: any;
  percentage: any = 100;
  PercentageValues = {
    developer_percentage: "",
    sharing_percentage: "",
    db_developer_percentage: "",
    db_sharing_percentage: "",
    interestPercentage: "",
  };
  phases: any;
  payment_plan_name: string;
  installments: string;

  constructor(
    private projectsService: ProjectsService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getAllFinishingTypes();
    this.getAllProjects();
    this.route.params.subscribe((res) => {
      this.payment_id = res.id;
      if (this.payment_id) {
        this.getPaymentPlanDetails();
      }
    });
  }

  getPaymentPlanForClone(clone_type) {
    this.slimLoadingBarService.start();
    this.projectsService
      .getPaymentPlanForClone(this.payment_id, clone_type)
      .subscribe((res: any) => {
        console.log(res);
        this.payment_plan_details_clone = res;
        let phasesRow = [];
        res.general.phases.forEach((row) => {
          phasesRow.push({
            id: row.phase_id,
            serial: row.serial,
          });
        });
        this.phases = phasesRow;
        this.percentage = 0;
        this.payment_plan_details_clone.extra_payments.forEach((row) => {
          this.extraPayments.push(row);
        });
        this.previewPayments = res;
        this.onProjectChange(res.general.project_id);
      });
  }

  getAllProjects() {
    this.projectsService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        this.projects = data;
        this.slimLoadingBarService.complete();
        this.getPaymentPlanForClone(this.clone_type);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getPaymentPlanDetails() {
    this.slimLoadingBarService.start();
    this.projectsService
      .getPaymentPlan(this.payment_id)
      .subscribe((res: any) => {
        console.log(res);
        this.installments = res.installments;
        this.payment_plan_name = res.plan_name;
        this.PercentageValues.interestPercentage = res.interest_percentage;
        this.PercentageValues.db_developer_percentage =
          res.db_developer_percentage;
        this.PercentageValues.db_sharing_percentage = res.db_sharing_percentage;
        this.PercentageValues.developer_percentage = res.developer_percentage;
        this.PercentageValues.sharing_percentage = res.sharing_percentage;
        this.phases = res.phases;
        res.extras.map((row) => {
          for (const key in row) {
            row[`extra_payment_${key}`] = row[key];
            delete row[key];
          }
        });
        this.currentSelectedProjectName = res.project.name;
        this.onFinishTypeChange(res.finishing_type_id);
        this.extraPayments = res.extras;
      });
  }

  getAllFinishingTypes() {
    this.slimLoadingBarService.complete();
    this.projectsService.getAllFinishingTypes().subscribe(
      (res: any) => {
        this.finishing_types = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  onProjectChange(value) {
    console.log(value);
    this.projects.forEach((project) => {
      if (value == project.id) {
        this.currentSelectedProjectName = project.name;
        this.phases = project.phases;
      }
    });
    console.log(this.currentSelectedProjectName);
  }

  onFinishTypeChange(id) {
    this.finishing_types.forEach((finish) => {
      if (finish.id == id) {
        this.finish_type_name = finish.name;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/view-payment-term/view-payment-term.component.ts